import { useEffect, useRef, useState } from 'react';

function useActiveSection(sectionIds, offsetMargin = '130px') {
  const [activeSection, setActiveSection] = useState();
  const observers = useRef({});

  useEffect(() => {
    sectionIds.forEach((id) => {
      const domNode = document.getElementById(id);

      if (domNode) {
        const observer = new IntersectionObserver(
          (entries) => {
            const [entry] = entries;

            // This will set the section to active when scrolling downwards or upwards
            if (entry.isIntersecting) {
              setActiveSection(id);
            }
          },
          {
            rootMargin: `-${offsetMargin} 0px -${window.innerHeight - parseInt(offsetMargin, 10) - 1}px 0px`,
          }
        );

        observer.observe(domNode);
        observers.current[id] = observer;
      }
    });

    // Cleanup
    return () => {
      Object.values(observers.current).forEach((observer) => observer.disconnect());
    };
  }, [sectionIds, offsetMargin]);

  return activeSection;
}

export default useActiveSection;
